/**
 * Organization Constants — Heart of Science v2
 * S10 Wave 1 (Organizations CRM)
 */

// Organization types
export const ORGANIZATION_TYPES = [
  'university',
  'research_institute',
  'corporate',
  'startup',
  'vc',
  'government',
  'ngo',
  'other',
] as const;
export type OrganizationType = typeof ORGANIZATION_TYPES[number];

export const ORGANIZATION_TYPE_LABELS: Record<OrganizationType, string> = {
  university: 'University',
  research_institute: 'Research Institute',
  corporate: 'Corporate',
  startup: 'Startup',
  vc: 'Venture Capital',
  government: 'Government',
  ngo: 'NGO',
  other: 'Other',
};

// Project-level organization roles
export const PROJECT_ORG_ROLES = [
  'originating_institution',
  'ip_owner',
  'partner',
  'investor',
  'customer',
  'corporate_sponsor',
] as const;
export type ProjectOrgRole = typeof PROJECT_ORG_ROLES[number];

export const PROJECT_ORG_ROLE_LABELS: Record<ProjectOrgRole, string> = {
  originating_institution: 'Originating Institution',
  ip_owner: 'IP Owner',
  partner: 'Partner',
  investor: 'Investor',
  customer: 'Customer',
  corporate_sponsor: 'Corporate Sponsor',
};
